export const backupWalletRoutes = [
  {
    path: ':walletId/backupWalletConfirmCaution',
    name: 'backup_confirm_caution',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/backup-wallet/ConfirmCaution.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.backup_process.title',
    },
  },
  {
    path: ':walletId/backupWalletInputPin',
    name: 'backup_wallet_pin',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletPin.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.backup_process.title',
    },
  },
  // {
  //   path: ':walletId/backupWalletOtpAuth',
  //   name: 'backup_wallet_otp',
  //   component: () =>
  //     import(
  //       '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletOtpAuth.vue'
  //     ),
  // },
  {
    path: ':walletId/backupWalletViewMnemonic',
    name: 'backup_wallet_view_mnemonic',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletViewMnemonic.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.backup_process.title',
    },
  },
  {
    path: ':walletId/backupWalletSortMnemonic',
    name: 'backup_wallet_sort_mnemonic',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletSortMnemonic.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.backup_process.title',
    },
  },
  {
    path: ':walletId/backupWalletComplete',
    name: 'backup_wallet_complete',
    component: () =>
      import(
        '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletComplete.vue'
      ),
    meta: {
      PageTitle: 'wallet_manage.backup_process.title',
    },
  },
]
